import { findSuggestionMatch } from '@tiptap/suggestion';
import type { SuggestionMatch, Trigger } from '@tiptap/suggestion';

export const FIELD_TRIGGER = '{{';

/**
 * Finds the `{{ … ` the caret is inside, if any.
 *
 * Wraps TipTap's own matcher because a two-character trigger needs two corrections that are
 * not obvious and fail quietly:
 *
 * 1. `allowedPrefixes` defaults to `[' ']`, which — measured — rejects EVERY match that has
 *    anything before it, a preceding space included. `"Pay {{amo"` does not match. Left at the
 *    default the picker only ever opens at the very start of a paragraph, which reads as it
 *    opening at random. Hence `allowedPrefixes: null`.
 * 2. `allowSpaces: true` is wanted, because people type `{{ name` with a space by habit. But
 *    the built-in matcher then never stops: after a finished `{{ amount }}` it keeps matching
 *    with a query of `" amount }} and the rest of the sentence"`. A closing brace means the
 *    token is already complete and the picker has no business being open, so a query
 *    containing one is rejected here.
 */
export const findFieldSuggestion = (config: {
	$position: Trigger['$position'];
	startOfLine?: boolean;
	allowToIncludeChar?: boolean;
}): SuggestionMatch => {
	const match = findSuggestionMatch({
		startOfLine: false,
		allowToIncludeChar: false,
		...config,
		char: FIELD_TRIGGER,
		allowSpaces: true,
		allowedPrefixes: null,
	});
	if (match === null) {
		return null;
	}
	if (match.query.includes('}')) {
		return null;
	}
	return { ...match, query: match.query.trim() };
};
